import type { AlpineComponent } from 'alpinejs';

type DialogProps = {
  modal: boolean;
};

type DialogData = {
  openDialog: () => void;
  closeDialog: () => void;
};

const Dialog = ({ modal }: DialogProps): AlpineComponent<DialogData> => ({
  openDialog() {
    if (modal) {
      (this.$refs.dialog as HTMLDialogElement).showModal();
    } else {
      (this.$refs.dialog as HTMLDialogElement).show();
    }
  },

  closeDialog() {
    (this.$refs.dialog as HTMLDialogElement).close();
  },
  init() {
    // Open dialog on button click
    const selector = `[data-js-dialog-toggle="${this.$refs.dialog.id}"]`;
    const toggle = document.querySelector(selector);
    if (toggle) {
      toggle.addEventListener('click', this.openDialog.bind(this));
    }
  }
});

export default Dialog;
